import { cloneElement } from '../../_util/vnode';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { computed, nextTick, ref, watch } from 'vue';
import ResizeObserver from '../../vc-resize-observer/index';
import { filterEmpty } from '../../_util/props-util';
import scrollIntoView from 'scroll-into-view-if-needed';
export const useArrowRender = (props, slots, onStepClick) => {
    const { status = 'process', prefixCls } = props;
    const arrow_container = ref();
    const arrow = ref();
    const arrow_client_width = computed(() => {
        return arrow.value?.clientWidth ?? 800;
    });
    // 每次点击移动距离为可视区域的百分之80
    const clickMoveWidth = computed(() => arrow_client_width.value * 0.8);
    const arrow_width = ref(0);
    const arrow_scroll_left = ref(0);
    const movableWidth = ref(Number.MAX_VALUE);
    const isCanSrcoll = ref(false);
    const showMoveControl = computed(() => {
        return props.showMoveControl && isCanSrcoll.value;
    });
    const showLeftShadow = ref(false);
    const showRightShadow = ref(true);
    watch([arrow_scroll_left, movableWidth, arrow_client_width], ([v1, v2]) => {
        if (v1 > 0) {
            showLeftShadow.value = true;
        }
        else if (v1 === 0) {
            showLeftShadow.value = false;
        }
        if (v1 < v2) {
            showRightShadow.value = true;
        }
        else if (v1 >= v2) {
            showRightShadow.value = false;
        }
    });
    const getScrollLef = () => {
        arrow_scroll_left.value = arrow.value.scrollLeft;
        if (!arrow_width.value) {
            arrow_width.value = arrow.value.scrollWidth;
        }
        if (movableWidth.value === Number.MAX_VALUE) {
            movableWidth.value = arrow.value.scrollWidth - arrow_client_width.value;
        }
    };
    const onClickMove = type => {
        let scrollLeft;
        if (type === 'right') {
            const result = arrow_scroll_left.value + clickMoveWidth.value;
            scrollLeft = result > movableWidth.value ? movableWidth.value : result;
        }
        else if (type == 'left') {
            const result = arrow_scroll_left.value - clickMoveWidth.value;
            scrollLeft = result < 0 ? 0 : result;
        }
        const scrollOption = {
            top: 0,
            left: scrollLeft,
            behavior: 'smooth',
        };
        arrow.value.scrollTo(scrollOption);
    };
    const scrollIntoFirst = (el, options) => {
        if (isCanSrcoll.value) {
            scrollIntoView(el, options ?? {
                behavior: 'smooth',
                scrollMode: 'if-needed',
                block: 'nearest',
                inline: 'start',
            });
        }
    };
    const isAuto = ref(true);
    const onResize = () => {
        isAuto.value = true;
        nextTick(() => {
            isCanSrcoll.value = arrow.value.scrollWidth > arrow.value.clientWidth;
            showRightShadow.value = isCanSrcoll.value;
            arrow_scroll_left.value = arrow.value.scrollLeft;
            isAuto.value = false;
        });
    };
    const arrowRender = () => {
        const children = filterEmpty(slots.default?.());
        return (<div ref={arrow_container} class={{
                [`${prefixCls}-arrow-has-icon`]: showMoveControl.value,
                [`${prefixCls}-arrow-container`]: true,
                [`${prefixCls}-arrow-has-scrollBar`]: !props.showMoveControl && isCanSrcoll.value,
                [`${prefixCls}-arrow-show-shadow-left`]: showLeftShadow.value,
                [`${prefixCls}-arrow-show-shadow-right`]: showRightShadow.value,
            }}>
        {showMoveControl.value && (<div class={{
                    [`${prefixCls}-arrow-move-icon`]: true,
                    [`${prefixCls}-arrow-move-disabled`]: !showLeftShadow.value,
                }} onClick={() => onClickMove('left')}>
            <LeftOutlined />
          </div>)}
        {showMoveControl.value && (<div class={{
                    [`${prefixCls}-arrow-shadow`]: true,
                    [`${prefixCls}-arrow-shadow-left`]: showLeftShadow.value,
                }}></div>)}
        <ResizeObserver onResize={onResize}>
          <div ref={arrow} class={`${prefixCls}-arrow`} onScroll={getScrollLef}>
            {children.map((child, index) => {
                const { prefixCls: pre = prefixCls, ...restProps } = child.props || {};
                const arrowProps = {
                    class: (!showMoveControl.value ? `${prefixCls}-arrow-not-scroll` : '') +
                        ' ' +
                        restProps.class,
                    key: index,
                    prefixCls: pre,
                    arrowIndex: index,
                    onStepClick,
                    scroll: isCanSrcoll.value,
                    auto: isAuto.value,
                };
                if (restProps.type !== 'no-arrow' && !restProps.status) {
                    if (index === props.current) {
                        arrowProps.status = status;
                    }
                    else if (index < props.current) {
                        arrowProps.status = 'finish';
                    }
                    else {
                        arrowProps.status = 'wait';
                    }
                }
                return cloneElement(child, arrowProps);
            })}
          </div>
        </ResizeObserver>
        {showMoveControl.value && (<div class={{
                    [`${prefixCls}-arrow-shadow`]: true,
                    [`${prefixCls}-arrow-shadow-right`]: showRightShadow.value,
                }}></div>)}
        {showMoveControl.value && (<div class={{
                    [`${prefixCls}-arrow-move-icon`]: true,
                    [`${prefixCls}-arrow-move-disabled`]: !showRightShadow.value,
                }} onClick={() => onClickMove('right')}>
            <RightOutlined />
          </div>)}
      </div>);
    };
    return { arrowRender, scrollIntoFirst, onResize };
};
